import React, {FC,} from 'react'
import {useEffectOnce} from 'react-use'
import {RouteComponentProps} from 'react-router-dom'
import {inject, observer} from 'mobx-react'
import {UserStoreProps} from '@/stores/user'
import Machine from '@/components/service'
import classnames from 'classnames'

import '@/styles/page/NewMachine.less'

export type NewMachineTypes = RouteComponentProps & UserStoreProps

const NewMachine: FC<NewMachineTypes> = inject('UserStore')(observer(props => {
  const {NewMachine} = props.UserStore

  const {prices, togglePayType, payType, totalPrice, groupList, groupId, changeGroupId, deviceList, toggleDevice, changePriceId, priceId, toggleAllSelected, selectedIds, allSelectStaut, deviceBuyNewMachine, indeterminate, deviceCol} = NewMachine
  useEffectOnce(() => {
    NewMachine.init()
  })

  return (
    <>
      <Machine.Prices prices={prices} changePriceId={changePriceId} priceId={priceId}/>
      <Machine.Device
        groupList={groupList} groupId={groupId} changeGroupId={changeGroupId}
        toggleAllSelected={toggleAllSelected} allSelectStaut={allSelectStaut}
        indeterminate={indeterminate}
      />
      <Machine.DeviceTable deviceList={deviceList} toggleDevice={toggleDevice} selectedIds={selectedIds} deviceCol={deviceCol}/>
      <Machine.PayMethod togglePayType={togglePayType} payType={payType} className={classnames('machine_pay_methods')}/>
      <Machine.Bottom totalPrice={totalPrice} deviceBuy={deviceBuyNewMachine}/>
    </>
  )
}))

export default NewMachine
